import React from 'react';
import PeopleLayout from '../layout/PeopleLayout';
import { UserTimeStackedBarChart } from '../../projects/components/WeeklyReport';

function TeamTime(props) {
  return <PeopleLayout {...props} content={<TeamTimeList {...props} />} />;
}

function TeamTimeList({ users, start, end }) {
  return (
    <div className="card mb-4">
      <div className="card-header">Your Team</div>
      <table className="table">
        <tbody>
          {users.map((user) => (
            <tr>
              <th style={{ width: '30%', whiteSpace: 'nowrap' }}>
                <a href={`/users/${user.id}/timesheets?start=${start}&end=${end}`}>{user.name}</a>
              </th>
              <td><UserTimeStackedBarChart user={user.id} start={start} end={end} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TeamTime;
